import { render, staticRenderFns } from "./noBuyList.vue?vue&type=template&id=4ab53193&scoped=true&"
import script from "./noBuyList.vue?vue&type=script&lang=js&"
export * from "./noBuyList.vue?vue&type=script&lang=js&"
import style0 from "./noBuyList.vue?vue&type=style&index=0&id=4ab53193&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab53193",
  null
  
)

export default component.exports